var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      style: _vm.modalStyle,
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        forceRender: true,
        fullscreen: "",
        switchFullscreen: "",
        wrapClassName: "ant-modal-cust-warp",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "a-button",
            {
              key: "templateSetting",
              attrs: { type: "primary", icon: "setting" },
              on: { click: _vm.handleTemplateSetting },
            },
            [_vm._v("模板设置")]
          ),
          _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
            _vm._v("关闭(ESC)"),
          ]),
        ],
        1
      ),
      _c(
        "a-form",
        { attrs: { form: _vm.form } },
        [
          [
            _c("iframe", {
              ref: "printIframe",
              staticStyle: { width: "100%", border: "none" },
              attrs: { src: _vm.billPrintUrl, height: _vm.height },
            }),
          ],
          [
            _c(
              "a-row",
              [
                _c(
                  "a-col",
                  [
                    _c(
                      "a-form-item",
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["id"],
                              expression: "['id']",
                            },
                          ],
                          attrs: { hidden: "" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }